import { stringify } from 'query-string';

import Api from 'entities/api';
import config from 'config';

export default (
  entity = 'donations',
  query: {
    [key: string]: any;
  },
  fileName: string
): Promise<never> => {
  const queryString = stringify(query);
  return new Promise((resolve) => {
    fetch(`${config.apiUrl}/api/${entity}?${queryString}`, {
      method: 'GET',
      headers: {
        Authorization: Api.defaultHeaders.Authorization,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
        resolve();
      })
      .catch(() => {
        resolve();
      });
  });
};
